import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, purple } from '../colors';
import { GetThemeOptions } from '@/theme/theme';
import { unityDarkTokens, unityLightTokens } from '@/theme/unityTokens';

export const newColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityLightTokens['--status-new-color-main'],
          highContrast: unityLightTokens['--status-new-color-high-contrast'],
          lowContrast: unityLightTokens['--status-new-color-low-contrast'],
        }
      : {
          main: unityDarkTokens['--status-new-color-main'],
          highContrast: unityDarkTokens['--status-new-color-high-contrast'],
          lowContrast: unityDarkTokens['--status-new-color-low-contrast'],
        };
  }

  return mode === 'light'
    ? {
        main: purple[500],
        highContrast: purple[700],
        lowContrast: purple[100],
      }
    : {
        main: purple[400],
        highContrast: purple[100],
        lowContrast: purple[800],
      };
};
